import React from 'react';
import {
  columnCode,
  columnDescription,
  columnName,
  columnNameLink,
  columnNameReference,
  hasColumn,
} from '@/constants/fields';
import entityIcons from '@/constants/images';
import SimpleCell from './SimpleCell';
import SelectableRow from './SelectableRow';
import NameCell from './NameCell';
import MarkdownCell from './MarkdownCell';

const NameDescriptionRow = ({
  asHref,
  children,
  className,
  code,
  columns = [],
  description,
  disabled,
  entity,
  error,
  href,
  icon,
  iconColour,
  loading,
  name,
  nameMessageId,
  onClick,
  onSelect,
  positive,
  renderSystemFlag,
  selectable,
  selected,
  system,
  warning,
}) => {
  const message = nameMessageId || `icon.${entity}`;
  const iconName = icon || entityIcons[entity];
  const isLink = hasColumn(columns, columnNameLink);
  const myHref = isLink ? href : undefined;
  const hasName = isLink || hasColumn(columns, [columnName, columnNameReference]);

  return ((
    <SelectableRow
      className={className}
      columns={columns}
      error={error}
      label={name}
      onClick={onSelect}
      positive={positive}
      selectable={selectable}
      selected={selected}
      warning={warning}
    >
      {hasName && (
        <NameCell
          disabled={disabled}
          href={asHref ? myHref : undefined}
          icon={iconName}
          iconColour={iconColour}
          link={asHref ? undefined : myHref}
          loading={loading}
          message={message}
          name={name}
          onClick={isLink ? onClick : undefined}
          renderSystemFlag={renderSystemFlag}
          system={system}
        />
      )}
      {hasColumn(columns, columnCode) && (<SimpleCell content={code} />)}
      {hasColumn(columns, columnDescription) && (<MarkdownCell className="td-description" value={description} />)}
      {children}
    </SelectableRow>
  ));
};

export default NameDescriptionRow;
